
import React, { FC, MouseEvent } from "react";
import './Modal.scss'
import { ModalProps } from "./Modal.types";
import close from "../Icon/svgs/modal-close.svg";
/**
 * The Modal component can be used to create different views.
 * Simply wrap your child components with the modal tags and they will appear in the modal.
 * 
 * Customization includes header styles (modalHeaderClass), the icon before the header (headerIconClass),
 * height, width, and border of the header itself.
 * For the purposes of the stories, the styles used are imported from a separate .scss file from the component itself.
 */
export const Modal: FC<ModalProps> = ({
  visible,
  width,
  height,
  shape,
  onClose,
  children,
  title,
  footer,
  placement,
  frosted,
  transparent,
  iconPath,
  headerIconClass,
  headerSeparator,
  modalHeaderClass,
  padding,
  modalContainerClass,
  dataTestId,
  modalContentClass,
  ...props
}) => {
  const modalStyle = { width, height, padding };

  const containerClass = visible && !transparent
    ? `alteon-modal-container active ${placement}`
    : !transparent && `alteon-modal-container ${placement}`;
  
  
  const containerClassTransparent = visible && transparent
  ? `alteon-modal-container-transparent active ${placement}`
  :  transparent && `alteon-modal-container-transparent ${placement}`;
  const containerTransparentClass = transparent && visible
  ? `transparent`
  :  `non-transparent`

  const modalClass = visible && !frosted
    ? `alteon-modal active alteon-modal-${shape} `
    : `alteon-modal-frosted active alteon-modal-${shape} `;

  

  const backdropClickHandler = (e: MouseEvent<HTMLDivElement>) => {
    const { target } = e;
    if (((target as HTMLDivElement).classList.contains("alteon-modal-container")
      || (target as HTMLDivElement).classList.contains("alteon-modal-container-transparent")) && typeof onClose === 'function') {
      onClose();
    }
  };

  const headerBorder = headerSeparator 
  ? "alteon-modal-header"
  : "alteon-modal-header-no-separator"
  return (
    <div  
      data-testid={dataTestId ? dataTestId : "alteon-modal-container-data-test-id"} className={ `${transparent ? containerClassTransparent : containerClass} ${containerTransparentClass}`} 
      {...props} 
      onClick={backdropClickHandler}
      >
      <div className={`${modalClass} ${modalContainerClass}` } style={modalStyle} >
        <div className={`${headerBorder} ${modalHeaderClass}` }>
          { typeof iconPath === "string" ? <img className={`alteon-modal-header-icon ${headerIconClass}`} src={iconPath} /> : iconPath }
          {title}
          { onClose && <div className="alteon-modal-close" onClick={onClose}>
            <img className="alteon-modal-close-svg" src={`${close}`} data-testid="modal-close"/>
          </div>
          }
        </div>
        <div className={`alteon-modal-content ${modalContentClass}`}>{children}</div>
        {footer && <div className="alteon-modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

Modal.defaultProps = {
  width: "32rem",
  shape: "basic",
  placement: "topCenter",
};
